function restoreUserDialogNew () {
  return {
    restrict: 'E',
    templateUrl: '/admin/dialogs/restore-user-new/restore-user-dialog-new.html?$$REVISION$$'
  }
}

export { restoreUserDialogNew }
